// SceneForm.form.js
import * as Yup from "yup";

export const departamentOptions = [
  { key: "edk", text: "Educamaker", value: "Educamaker" },
  { key: "ext", text: "External", value: "External" },
  // Agrega más departamentos según sea necesario
];

export const accountOptions = [
  { key: "creator", text: "creator", value: "creator" },
];
export const idscene = [{ key: "idScene", text: "idScene", value: "External" }];

// Valores iniciales
export function initialValuesZero(scene) {
  return {
    departament: scene?.departament || "Educamaker",
    idScene: scene?.idScene || "External",
    account: scene?.account || "creator",
  };
}

// Esquema de validación
export function validationSchemaZero() {
  return Yup.object({
    departament: Yup.string().required("El departamento es obligatorio"),
    idScene: Yup.string().required("El ID de la escena es obligatorio"),
    account: Yup.string().required("Selecciona el tipo de cuenta"),
  });
}
